import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d91eb662"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-lg-6 col-12" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mt-md" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Jak możemy pomóc?")
], -1))
const _hoisted_4 = { class: "row mt-sm" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, null, -1))
const _hoisted_6 = { class: "col-3 p-0" }
const _hoisted_7 = {
  class: "btn-gradient d-flex justify-content-center align-items-center pt-3 pb-3",
  style: {"border-radius":"5px 0 0 5px"}
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "under-button-text" }, "pytanie", -1))
const _hoisted_9 = { class: "col-3 p-0 ms-1 me-1" }
const _hoisted_10 = {
  href: "#",
  class: "text-decoration-none"
}
const _hoisted_11 = { class: "btn-gradient d-flex justify-content-center align-items-center pt-3 pb-3" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "under-button-text" }, "czat", -1))
const _hoisted_13 = { class: "col-3 p-0" }
const _hoisted_14 = ["href"]
const _hoisted_15 = {
  class: "btn-gradient d-flex justify-content-center align-items-center pt-3 pb-3",
  style: {"border-radius":"0 5px 5px 0"}
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "under-button-text" }, "telefon", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-6 col-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "index-img mt-md" }, [
    /*#__PURE__*/_createElementVNode("img", { src: "/static/images/index-page/consultant.png" })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_question_icon = _resolveComponent("question-icon")!
  const _component_communication_icon = _resolveComponent("communication-icon")!
  const _component_phone_icon = _resolveComponent("phone-icon")!
  const _component_improvement_form_modal = _resolveComponent("improvement-form-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("a", {
            class: "text-decoration-none",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$refs['modal'].open()))
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_question_icon)
            ]),
            _hoisted_8
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("a", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_communication_icon)
            ]),
            _hoisted_12
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("a", {
            href: `tel:${_ctx.getPhoneNumber}`,
            class: "text-decoration-none"
          }, [
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_phone_icon)
            ]),
            _hoisted_16
          ], 8, _hoisted_14)
        ])
      ])
    ]),
    _hoisted_17,
    _createVNode(_component_improvement_form_modal, {
      "form-type": _ctx.FormTypes.GENERAL,
      ref: "modal"
    }, null, 8, ["form-type"])
  ]))
}